import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from '@material-ui/styles';
import { StylesProvider } from '@material-ui/core/styles';
import { BrowserRouter } from 'react-router-dom';

import { theme } from './utils/materialTheme';
import Solaris from 'components/SolarisCalculatorWrapper/Solaris';

import './utils/i18n';

// Load roboto font
import 'fontsource-roboto-slab/latin-400.css';
import 'fontsource-roboto-slab/latin-700.css';
import 'fontsource-roboto-slab/greek-400.css';
import 'fontsource-roboto-slab/greek-700.css';
// Load global styles
import './styles/index.scss';

import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <React.StrictMode>
    <StylesProvider injectFirst>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Solaris />
        </BrowserRouter>
      </ThemeProvider>
    </StylesProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
